module.exports = __webpack_public_path__ + "templates/officeSearch.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/core/components/officeSearch/officeSearch.html
// module id = 279
// module chunks = 15